import { createFormFromSchema, ObservableForm } from "@corets/form"
import { object, string } from "@corets/schema"
import { AxiosInstance } from "axios"
import { createReflection, updateReflection } from "../../../services/api/reflectionProcessing"
import { Reflection } from "../../../units/types/reflection"
import { ReflectionRequest } from "../../../units/types/reflectionFieldRequest"

export const createCreateOrUpdateReflectionProcessingForm = (
  api: AxiosInstance,
  data?: Reflection
): ObservableForm<ReflectionRequest, boolean> => {
  const form = createFormFromSchema<ReflectionRequest, boolean>(
    object<ReflectionRequest>({
      id: string()
        .optional()
        .toDefault(data?.id?.toString() || ""),
      name: string()
        .required(true, "Bắt buộc")
        .toDefault(data?.name || ""),
      address: string()
        .required(true, "Bắt buộc")
        .toDefault(data?.address || ""),
      phoneNumber: string()
        .required(true, "Bắt buộc")
        .matches(/(84|0[3|5|7|8|9])+([0-9]{8})\b/, "Số điện thoại không đúng định dạng")
        .toDefault(data?.phoneNumber || ""),
    })
  ).handler(async (form) => {
    const datas = await form.get()

    if (data) {
      const res = await updateReflection(api, datas)
      if (res?.content?.status) return true
    } else {
      delete datas.id
      const res = await createReflection(api, datas)
      if (res?.content?.status) return true
    }
    return false
  })

  return form
}
